import * as React from 'react'
import { autobind } from 'core-decorators'
import { observer } from 'mobx-react'
import { IoIosInformationCircleOutline, IoIosArrowBack, IoIosArrowForward } from 'react-icons/io'
import { FormattedMessage } from 'react-intl'
import { IReviewStore, IApplicationStore } from '../../stores'
import AboutDialog from '../Header/modals/AboutDialog'
import ReviewCenterChat from '../ReviewPanel/ReviewCenterChat'
import ReviewUsers from '../ReviewUsers/ReviewUsers'

import './Sidebar.scss'

interface ISidebar {
  reviewStore: IReviewStore,
  applicationStore: IApplicationStore
}
interface IState {
  showAboutModal: boolean,
  showUsers: boolean
}

@observer
export default class Sidebar extends React.Component<ISidebar> {
  state: IState

  constructor(props: ISidebar) {
    super(props)
    this.state = {
      showAboutModal: false,
      showUsers: false
    }
  }

  @autobind
  handleAboutDialog(): void {
    this.setState({
      showAboutModal: true
    })
  }

  @autobind
  handleSlide() {
    this.setState({
      showUsers: !this.state.showUsers
    })
  }

  @autobind
  closeAboutModal(): void {
    this.setState({
      showAboutModal: false
    })
  }

  render() {
    const reviewModel = this.props.reviewStore.current
    const totalCount =
      (reviewModel ? reviewModel.users.length : 0)
      + (reviewModel ? reviewModel.inviters.length : 0)


    return (
      <div
        className="sidebar-inner-container"
        style={{ right: this.state.showUsers ? '38px' : '-300px' }}
      >
        <div className="sidebar-slide">
          <div className="slide-to-users" onClick={this.handleSlide}>
            <FormattedMessage id="sidebar.slide.users" values={{ count: totalCount }} />
            <IoIosArrowForward
              size={18}
              color="#000"
            />
          </div>
          <div className="slide-to-chat" onClick={this.handleSlide}>
            <IoIosArrowBack
              size={18}
              color="#000"
            />
            <FormattedMessage id="sidebar.slide.chat" />
          </div>
        </div>
        <div className="sidebar-body-container">
          <div className="sidebar-chat">
            {
              reviewModel
                ? <ReviewCenterChat
                  applicationStore={this.props.applicationStore}
                  reviewModel={reviewModel}
                  reviewStore={this.props.reviewStore}
                />
                : null
            }
            <div
              className="show-about-dialog"
              onClick={this.handleAboutDialog}
            >
              <IoIosInformationCircleOutline
                size={20}
                color="#000"
              />
            </div>
            {this.state.showAboutModal
              ? <AboutDialog
                {...this.props}
                show={this.state.showAboutModal}
                handleClose={this.closeAboutModal}

              />
              : null
            }
          </div>
          <div className="sidebar-users">
            {
              reviewModel
                ? <ReviewUsers
                  users={reviewModel.users}
                  reviewModel={reviewModel}
                  inviters={reviewModel.inviters}
                />
                : null
            }
          </div>
        </div>

      </div>
    )
  }
}
